import { Campaign } from '@mui/icons-material';
import { Dialog, DialogProps, Typography } from '@mui/material';

import { colors } from 'config/theme';

import { AlertWrapper, HR, ButtonWrapper } from './styledComponents';

interface AlertModalProps extends DialogProps {
  heading: string;
  subHeading?: string;
  children: React.ReactNode;
}
export const AlertModal: React.FC<AlertModalProps> = ({
  heading,
  subHeading,
  children,
  ...rest
}) => {
  return (
    <Dialog {...rest}>
      <AlertWrapper>
        <Campaign sx={{ color: colors.uswds.redCool50, fontSize: '60px' }} />
        <Typography sx={{ mb: 2 }} variant='h4'>
          {heading}
        </Typography>
        {subHeading && (
          <Typography align='center' variant='body1'>
            {subHeading}
          </Typography>
        )}
        <HR />
        <ButtonWrapper>{children}</ButtonWrapper>
      </AlertWrapper>
    </Dialog>
  );
};
